export default {"src":"/_next/static/media/logo-popcard.ba88da8d.svg","height":208,"width":809,"blurWidth":0,"blurHeight":0};